<template>
	<div class="news-filter-container">
		<div class="line-cta-container d-flex flex-v-centre">
			<hr />
			<div class="news-filter">
				<div class="select-holder">
					<Select v-model="model" :options="yearsOptions" option-label="label" option-value="value" placeholder="Filter by year" append-to="self" @change="onFilterChange"> </Select>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { Select } from 'primevue';

	const props = defineProps({
		url: {
			type: String,
			required: true,
		},
		years: {
			type: String,
			required: true,
		},
	});

	const model = defineModel<number>({ type: Number, required: false });

	const yearsOptions = JSON.parse(props.years).map((year: number) => ({ label: year.toString(), value: year }));
	yearsOptions.unshift({ label: 'All years', value: null });

	const onFilterChange = () => {
		const year = model.value?.toString() ?? '';
		if (year) {
			const params = new URLSearchParams({ year }).toString();
			window.location.href = `${props.url}?${params}`;
		} else {
			window.location.href = props.url;
		}
	};
</script>
